import { Header, SideBar } from "components"
import { AnimatePresence, motion } from "framer-motion"
import { useDispatch, useSelector } from "react-redux"
import { show } from "../../store/Slices/sidebar-hide"
import openMenu from "./open-menu-icon.png"

export const Layout = (props: any) => {
 const dispatch = useDispatch()

 const isHidden = useSelector((state: any) => state.hide)

 const handleShow = () => {
  dispatch(show()) // Dispatch the show action
 }

 return (
  <div className="w-full  mx-auto">
   <div className="relative z-20">
    <Header />
   </div>
   <div className="md:flex flex-unset ">
    <AnimatePresence>
     {!isHidden && (
      <motion.div
       className={`min-h-[80vh] lg:block hidden `}
       initial={{ width: "0%" }}
       animate={{ width: isHidden ? "-40px" : "20%" }}
       exit={{ width: "0%", opacity: 0 }}
       transition={{ duration: 0.7, ease: "easeInOut" }}
      >
       <SideBar />
      </motion.div>
     )}
    </AnimatePresence>
    <div className="relative mt-4 h-[80vh] hidden lg:block">
     {isHidden && (
      <button
       className="w-[40px] "
       type="button"
       onClick={() => {
        handleShow()
       }}
      >
       <img className="pl-2" width={45} src={openMenu} alt="menu" />
      </button>
     )}
    </div>

    <div
     className={`lg:w-[80%] w-full ${
      isHidden ? "lg:w-full mx-auto  transition-all duration-700 " : " "
     }`}
    >
     {props.children}
    </div>
   </div>
  </div>
 )
}
